import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Button, Checkbox, Link, Modal } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../../../../formLayout.scss";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import IconButton from "@mui/material/IconButton";
import ModulePermissionAccessControl from "../../../../../../Components/Broker/ModulePermissionAccessControl/ModulePermissionAccessControl";
import MultipleSearchDropdown from "../../../../../../Supporting files/MultipleSearchDropdown/MultipleSearchDropdown";
import RKTextField from "../../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../../Supporting files/SearchDropdown/SearchDropdown";
interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

function CreateUsers() {
  const navigate = useNavigate();

  const [selectedClientList, setSelectedClientList] = useState([]);
  const [fullName, setFullName] = React.useState("");
  const [roleName, setRoleName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [role, setRole] = React.useState("");
  const [branch, setBranch] = React.useState("");
  const [Department, setDepartment] = React.useState("");
  const [singleUse, setSingleUse] = React.useState("");
  const [selectClient, setSelectClient] = React.useState("");
  const [clientList, setClientList] = React.useState("");
  const [searchList, setSearchList] = useState<boolean>(false);
  const [contacts, setContacts] = useState<
    Array<{
      checkbox_status: boolean;
      id: number;
      name: string;
    }>
  >([
    {
      checkbox_status: false,
      id: 0,
      name: "All Clients",
    },
    {
      checkbox_status: false,
      id: 1,
      name: "EV0065 - Vikas Saini",
    },
    {
      checkbox_status: false,
      id: 2,
      name: "EV007 - Umesh Gemini",
    },
    {
      checkbox_status: false,
      id: 3,
      name: "EV0016 - Kartike Kakkar",
    },
    {
      checkbox_status: false,
      id: 4,
      name: "EV0065 - Vikas Saini",
    },
    {
      checkbox_status: false,
      id: 5,
      name: "EV007 - Umesh Gemini",
    },
    {
      checkbox_status: false,
      id: 6,
      name: "EV0016 - Kartike Kakkar",
    },
    {
      checkbox_status: false,
      id: 7,
      name: "EV0065 - Vikas Saini",
    },
    {
      checkbox_status: false,
      id: 8,
      name: "EV007 - Umesh Gemini",
    },
    {
      checkbox_status: false,
      id: 9,
      name: "EV0016 - Kartike Kakkar",
    },
  ]);
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("userInformation");
  const [subSection, setSubSection] = React.useState<string>("basics");

  const role_data = [
    { label: "Admin", value: "Admin" },
    { label: "Member", value: "Member" },
    { label: "Super Admin", value: "Super Admin" },
    { label: "Custom", value: "Custom" },
  ];
  const branch_data = [
    { label: "Head Branch", value: "Head Branch" },
    { label: "Head Branch", value: "Head Branch" },
    { label: "Head Branch", value: "Head Branch" },
  ];
  const Department_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const clientList_data = [
    { key: "Vikas Saini", year: "Vikas Saini" },
    { key: "Rohit Manlotia", year: "Rohit Manlotia" },
    { key: "Umeh Gemini", year: "Umeh Gemini" },
    { key: "Kartike Kakkar", year: "Kartike Kakkar" },
    { key: "Vikas Saini", year: "Vikas Saini" },
    { key: "Rohit Manlotia", year: "Rohit Manlotia" },
    { key: "Umeh Gemini", year: "Umeh Gemini" },
    { key: "Kartike Kakkar", year: "Kartike Kakkar" },
    { key: "Vikas Saini", year: "Vikas Saini" },
    { key: "Rohit Manlotia", year: "Rohit Manlotia" },
    { key: "Umeh Gemini", year: "Umeh Gemini" },
    { key: "Kartike Kakkar", year: "Kartike Kakkar" },
  ];
  useEffect(() => {
    console.log(searchList, "Umesh");
  }, [searchList]);

  const selectClient_data = [
    {
      label: "Custom",
      value: "Custom",
    },
    { label: "All", value: "All" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  // for scrolling
  const userInformation = useRef(null);
  const basics = useRef(null);
  const clientInfo = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const searchHandler = (event: any) => {
    let searcjQery = event.target.value.toLowerCase(),
      displayedContacts = CONTACTS.filter((el) => {
        let searchValue = el.name.toLowerCase();
        return searchValue.indexOf(searcjQery) !== -1;
      });
    setContacts(displayedContacts);
    setSearchList(true);
  };

  const selectClientsFromList = (index: number, check_status: boolean) => {
    let data = contacts;

    data[index].checkbox_status = check_status;
    setContacts(data);
    console.log(check_status);
  };
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3>Create New User</h3>
          </div>
        </Grid>
        <Grid xs={6}></Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection">
              <Link
                className={
                  sectionStatus === "userInformation"
                    ? "active sectionLink userInformation"
                    : "sectionLink userInformation"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(userInformation);
                  SetSectionStatus("userInformation");
                }}
              >
                <span> User Information</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basics"
                        ? "inner_link active basics"
                        : "inner_link  basics"
                    }
                    onClick={() => {
                      handleClicks(subSection);
                      scrollToSection(basics);
                      setSubSection("basics");
                    }}
                  >
                    Basic Info
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "clientInfo"
                        ? "inner_link active clientInfo"
                        : "inner_link clientInfo"
                    }
                    onClick={() => {
                      setSubSection("clientInfo");
                      handleClicks(subSection);
                      scrollToSection(clientInfo);
                    }}
                  >
                    Client Info
                  </Link>
                </li>
              </ul>
            </Grid>
            <Grid xs className="rightSection">
              <Box className="detailSection" ref={userInformation}>
                <div ref={basics}>
                  <div className="sectionTitle">
                    <h4>User Information</h4>
                  </div>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Basic Info</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextField
                        class_name="inputField"
                        title={"Full Name"}
                        value={fullName}
                        attrName={setFullName}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextField
                        class_name="inputField"
                        title={"Email"}
                        value={email}
                        attrName={setEmail}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>

                    <Grid sm={4} md={4} lg={3} xl={2}>
                      <SearchDropdown
                        class_name="inputField"
                        title="Role"
                        value={role}
                        attrName={setRole}
                        value_update={updateMasterState}
                        data={role_data}
                        warn_status={false}
                        error_message="Please select Role"
                      />
                    </Grid>
                    {role === "Custom" ? (
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <RKTextField
                          class_name="inputField"
                          title={"Role Name"}
                          value={roleName}
                          attrName={setRoleName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    ) : null}
                    <Grid sm={4} md={4} lg={3} xl={2}>
                      <SearchDropdown
                        class_name="inputField"
                        title="Branch"
                        value={branch}
                        attrName={setBranch}
                        value_update={updateMasterState}
                        data={branch_data}
                        warn_status={false}
                        error_message="Please select Branch"
                      />
                    </Grid>
                    <Grid sm={6} md={5} lg={3} xl={3}>
                      <SearchDropdown
                        class_name="inputField"
                        title="Department"
                        value={Department}
                        attrName={setDepartment}
                        value_update={updateMasterState}
                        data={Department_data}
                        warn_status={false}
                        error_message="Please select department"
                      />
                    </Grid>
                    <Grid sm={6} md={4} lg={3} xl={3}>
                      <RKTextField
                        class_name="inputField"
                        title={"Single Use Password"}
                        value={singleUse}
                        attrName={setSingleUse}
                        value_update={updateMasterState}
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div ref={clientInfo}>
                  <Grid container spacing={3}>
                    <Grid xs={12}>
                      <h5 className="subHeading">Client Info</h5>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3}>
                    {/* <Grid sm={6} md={5} lg={3} xl={3}>
                      <SearchDropdown
                        class_name="inputField"
                        title="Select Client"
                        value={selectClient}
                        attrName={setSelectClient}
                        value_update={updateMasterState}
                        data={selectClient_data}
                        warn_status={false}
                        error_message="Please select client"
                      />
                    </Grid> */}
                    <Grid sm={12}>
                      <div className="custom_dropdown">
                        <div
                          className="custom_input"
                          onClick={() => {
                            setSearchList(true);
                          }}
                        >
                          {contacts.map((data, index) => (
                            <div className="custom_field">
                              {data.checkbox_status === true ? (
                                <span>
                                  {data.name}
                                  <IconButton
                                    onClick={(e) =>
                                      selectClientsFromList(index, false)
                                    }
                                  >
                                    <CloseOutlinedIcon />
                                  </IconButton>
                                </span>
                              ) : null}
                            </div>
                          ))}
                          <input
                            type="text"
                            className="search"
                            onChange={searchHandler}
                          />

                          <label>Client List</label>
                        </div>
                        {searchList === true ? (
                          <div className="customDropdownList">
                            <div className="innerContainer">
                              <Link
                                className="cross"
                                onClick={() => {
                                  setSearchList(false);
                                }}
                              ></Link>
                              <ul>
                                {contacts.map((data, index) => {
                                  return (
                                    <li>
                                      <div>
                                        <Checkbox
                                          defaultChecked={data.checkbox_status}
                                          value={data.checkbox_status}
                                          onClick={(e) =>
                                            selectClientsFromList(
                                              index,
                                              !data.checkbox_status
                                            )
                                          }
                                        />
                                        {/* <label className="employee"></label> */}
                                      </div>
                                      {` ${data.name}`}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </Grid>
                  </Grid>
                </div>

                {role === "Custom" ? <ModulePermissionAccessControl /> : null}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button variant="outlined" className="borderBtn">
            Cancel
          </Button>

          <Button
            variant="contained"
            className="submitBtn"
            onClick={() => {
              navigate(-1);
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>

      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to Delete this Attatchment.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}

export default CreateUsers;

const CONTACTS: Array<{
  checkbox_status: boolean;
  id: number;
  name: string;
}> = [
  {
    checkbox_status: false,
    id: 1,
    name: "EV0065 - Vikas Saini",
  },
  {
    checkbox_status: false,
    id: 2,
    name: "EV007 - Umesh Gemini",
  },
  {
    checkbox_status: false,
    id: 3,
    name: "EV0016 - Kartike Kakkar",
  },
  {
    checkbox_status: false,
    id: 4,
    name: "EV0065 - Vikas Saini",
  },
  {
    checkbox_status: false,
    id: 5,
    name: "EV007 - Umesh Gemini",
  },
  {
    checkbox_status: false,
    id: 6,
    name: "EV0016 - Kartike Kakkar",
  },
  {
    checkbox_status: false,
    id: 7,
    name: "EV0065 - Vikas Saini",
  },
  {
    checkbox_status: false,
    id: 8,
    name: "EV007 - Umesh Gemini",
  },
  {
    checkbox_status: false,
    id: 9,
    name: "EV0016 - Kartike Kakkar",
  },
];
